import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import './index.css';
import './I18nextConfig';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

